"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.RejectInteractionMsg = exports.ApproveInteractionMsg = void 0;
const router_1 = require("@keplr-wallet/router");
const constants_1 = require("./constants");
class ApproveInteractionMsg extends router_1.Message {
    constructor(id, result) {
        super();
        this.id = id;
        this.result = result;
    }
    static type() {
        return "approve-interaction";
    }
    validateBasic() {
        // noop
    }
    route() {
        return constants_1.ROUTE;
    }
    type() {
        return ApproveInteractionMsg.type();
    }
}
exports.ApproveInteractionMsg = ApproveInteractionMsg;
class RejectInteractionMsg extends router_1.Message {
    constructor(id) {
        super();
        this.id = id;
    }
    static type() {
        return "reject-interaction";
    }
    validateBasic() {
        // noop
    }
    route() {
        return constants_1.ROUTE;
    }
    type() {
        return RejectInteractionMsg.type();
    }
}
exports.RejectInteractionMsg = RejectInteractionMsg;
//# sourceMappingURL=messages.js.map